import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item", "name", "text", "category", "group", "nav", "empty", "term"]

  filter() {
    const query = this.inputTarget.value.trim()
    if (!query) {
      this.reset()
      return
    }

    const needle = this.normalize(query)
    let visibleCount = 0

    this.itemTargets.forEach((item) => {
      const haystack = this.normalize(this.itemText(item))
      const match = haystack.includes(needle)
      item.hidden = !match
      if (match) visibleCount += 1
    })

    this.highlightAll(query)

    this.categoryTargets.forEach((category) => {
      const hasItem = category.querySelector("[data-menu-search-target='item']:not([hidden])")
      category.hidden = !hasItem
    })

    if (this.hasGroupTarget) {
      this.groupTargets.forEach((group) => {
        const hasCategory = group.querySelector("[data-menu-search-target='category']:not([hidden])")
        group.hidden = !hasCategory
      })
    }

    this.navTargets.forEach((link) => {
      const id = link.dataset.categoryId
      const category = this.categoryTargets.find((el) => el.dataset.categoryId === id)
      link.hidden = !category || category.hidden
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.hidden = visibleCount > 0
      if (this.hasTermTarget) this.termTarget.textContent = query
    }
  }

  clear() {
    this.inputTarget.value = ""
    this.reset()
    this.inputTarget.focus()
  }

  reset() {
    this.itemTargets.forEach((item) => { item.hidden = false })
    this.categoryTargets.forEach((category) => { category.hidden = false })
    if (this.hasGroupTarget) this.groupTargets.forEach((group) => { group.hidden = false })
    this.navTargets.forEach((link) => { link.hidden = false })
    if (this.hasEmptyTarget) this.emptyTarget.hidden = true
    this.highlightAll("")
  }

  itemText(item) {
    const name = item.querySelector("[data-menu-search-target='name']")
    const text = item.querySelector("[data-menu-search-target='text']")
    return [name?.dataset.original || name?.textContent, text?.dataset.original || text?.textContent]
      .filter(Boolean)
      .join(" ")
  }

  highlightAll(query) {
    this.nameTargets.forEach((el) => this.highlight(el, query))
    if (this.hasTextTarget) this.textTargets.forEach((el) => this.highlight(el, query))
  }

  highlight(el, query) {
    const original = el.dataset.original ?? el.textContent
    el.dataset.original = original
    if (!query) {
      el.textContent = original
      return
    }

    const needle = this.normalize(query)
    const parts = []
    let cursor = 0

    while (cursor < original.length) {
      const fromHere = original.slice(cursor)
      const norm = this.normalize(fromHere)
      const at = norm.indexOf(needle)
      if (at === -1) {
        parts.push(document.createTextNode(fromHere))
        break
      }

      const start = cursor + this.originalIndex(fromHere, at)
      const end = cursor + this.originalIndex(fromHere, at + needle.length)
      if (start > cursor) parts.push(document.createTextNode(original.slice(cursor, start)))

      const mark = document.createElement("mark")
      mark.className = "menu-mark"
      mark.textContent = original.slice(start, end)
      parts.push(mark)
      cursor = end
    }

    el.replaceChildren(...parts)
  }

  originalIndex(str, normIndex) {
    let consumed = 0
    for (let i = 0; i < str.length; i += 1) {
      if (consumed >= normIndex) return i
      consumed += this.normalize(str[i]).length
    }
    return str.length
  }

  normalize(value) {
    return value.toString().normalize("NFD").replace(/\p{M}/gu, "").toLowerCase()
  }
}
